import { z } from 'zod';
import { useTranslation } from 'react-i18next';
import { BankAccountForm } from './bank-account';

export default function VirtualAccountForm({
  mode,
  bank,
  rail,
  requiredFields,
  canEdit = true,
  isOnboarding = false,
}) {
  const { t } = useTranslation(['onboarding', 'common']);

  const wireSchema = z.object({
    rail: z.string().min(1, t('common:required_field')),
    account_holder_name: z.string().min(1, t('common:required_field')),
    account_holder_type: z.string().min(1, t('common:required_field')),
    provider: z.string().min(1, t('common:required_field')),
    virtual_account_id: z.string().min(1, t('common:required_field')),
    payoneer_email: z.string().optional().or(z.literal('')),
    routing_number: z
      .string()
      .min(1, t('common:required_field'))
      .regex(/^\d{9}$/, t('rounting_min')),
    account_number: z
      .string()
      .min(1, t('common:required_field'))
      .regex(/^\d+$/, t('common:invalid_characters')),
    account_class: z.string().min(1, t('common:required_field')),
    bank_name: z.string().min(1, t('common:required_field')),
    bank_country: z.string().min(1, t('common:required_field')),
    bank_address: z.string().min(1, t('common:required_field')),
  }).superRefine((data, ctx) => {
    if (data.provider === 'payoneer') {
      if (!data.payoneer_email || data.payoneer_email.trim() === '') {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['payoneer_email'],
          message: t('common:required_field'),
        });
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.payoneer_email)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['payoneer_email'],
          message: t('common:invalid_email'),
        });
      }
    }
  });

  return (
    <div className='space-y-4'>
      <BankAccountForm
        mode={mode}
        bank={{
          rail: 'VIRTUAL',
          account_holder_name: bank?.account_holder_name || '',
          provider: bank?.provider || 'payoneer',
          virtual_account_id: bank?.virtual_account_id || '',
          payoneer_email: bank?.payoneer_email || '',
          routing_number: bank?.routing_number || '',
          account_number: bank?.account_number || '',
          account_class: bank?.account_class || 'CHECKING',
          bank_name: bank?.bank_name || '',
          bank_country: bank?.bank_country || 'US',
          bank_address: bank?.bank_address || '',
          account_holder_type: bank?.account_holder_type || 'INDIVIDUAL',
          id: bank?.id || '',
        }}
        rail={'VIRTUAL'}
        requiredFields={requiredFields}
        schema={wireSchema}
        canEdit={canEdit}
        isOnboarding={isOnboarding}
      />
    </div>
  );
}